/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export class AppointmentImport {
  constructor(json: JSON | any) {
    Object.assign(this as AppointmentImport, json)
  }

  comments?: string
  externalCustomerId?: string
  customerId?: string
  customerComments?: string
  title?: string
  endTime?: number
  startTime?: number
  type?: string
  appointmentTypeId?: string
  ownerRef?: string
  customerName?: string
  customerFirstname?: string
  customerEmail?: string
  city?: string
  postcode?: string
  street?: string
  sex?: string
  externalId?: string
  customerBirthDate?: number
  customerGsm?: string
  customerFixPhone?: string
}
